import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent } from '@fuse';
import IconButton from 'material-ui/IconButton';
//import { Button, FormControlLabel, MenuItem, Radio, Typography, Icon, IconButton } from 'material-ui';
import { InputLabel, Select as MSelect, Radio, MenuItem, TextField, Checkbox, FormControlLabel, Divider, Button, Paper, Typography, FormControl, FormHelperText } from 'material-ui';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';

import ReactTable from "react-table";
import axios from 'axios/index';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import ItemAdder from "main/content/sales/billing/itemAdder";
import { withAlert } from 'react-alert';

import Select from 'react-select';
import moment from 'moment';
import 'react-select/dist/react-select.css'
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { confirmAlert } from 'react-confirm-alert';
import { ifError } from 'assert';
import Icon from 'material-ui/Icon';


const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0
    }
});

var reference_no = null;
class DeliveryNoteView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,

            deliveryOrders: []
        };

        // this.getInvoiceDetails();
        this.populateData();
    }

    populateData() {
        this.getDeliveryNotes();
    }

    getDeliveryNotes() {
        this.setState({ loading: true });

        var url = window.salesServer + "/invoice/getDeliveryNotes";
        const request = axios.get(url);

        request.then((response) => {
            if (response.data && response.data.success) {
                if (response.data.result) {
                    this.setState({ deliveryOrders: response.data.result })
                }
                else {
                    this.setState({ deliveryOrders: [] })
                }
                this.setState({ loading: false })
            }
            else {
                console.log('getDeliveryNotes response not valid', response);
                this.setState({ loading: false })
            }
        })
            .catch((error) => {
                if (error != undefined) {
                    console.log('getDeliveryNotes error', error);
                }
                else {
                    console.log('getDeliveryNotes error');
                }
                this.setState({ loading: false })
            });
    }

    getDeliveryNoteReport(deliveryId) {
        console.log('getDeliveryNoteReport called', deliveryId);
        var path = null;
        // axios.get('http://localhost:5008/report/get/deliveryNote', {
        axios.get(window.reportServer + '/report/get/deliveryNoteForImc', {
            params: {
                id: deliveryId
            }
        })
            .then(response => {
                console.log('getDeliveryNoteReport path', response);
                path = response.data.path;
                path = window.reportServer + "/" + path;
                // path = "http://localhost:5008/" + path;
                const url = path;
                window.open(url, '_blank');
            }
            )
            .catch((error) => {
                if (error) {
                    console.log('getDeliveryNoteReport error', error);
                } else {
                    console.log('getDeliveryNoteReport error');
                }
            });
    }

    onPrint = (invoice_id) => {
        // alert(this.state.search_type +"rtrt -"+invoice_id)
        if (this.state.search_type == 'quatation') {
            var path = null;
            axios.get(window.reportServer + '/report/get/reportQuotationDuplicate',
                {
                    params: {
                        refId: invoice_id
                    }
                }
            )
                .then(response => {
                    path = response.data.path;
                    path = window.reportServer + "/" + path;
                    const url = path;
                    window.open(url, '_blank');
                }
                );
        } else if (this.state.search_type == 'proformaInvoice') {
            var address = null;
            axios.get(window.reportServer + '/report/get/reportInvoiceDuplicate', {
                params: {
                    invoiceNo: invoice_id
                }
            })
                .then(response => {
                    address = response.data.path;
                    address = window.reportServer + "/" + address;
                    const url = address;
                    window.open(url, '_blank');


                }
                );
        } else {
            var address = null;
            axios.get(window.reportServer + '/report/get/reportInvoiceDuplicate', {
                params: {
                    invoiceNo: invoice_id
                }
            })
                .then(response => {
                    address = response.data.path;
                    address = window.reportServer + "/" + address;
                    const url = address;
                    window.open(url, '_blank');


                }
                );
        }


    };

    componentWillMount() { }

    render() {


        const { classes } = this.props;

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="pl-8">
                    <div className="p-8">
                        <h2 className="subtitle-color invoice-margin">Delivery Order View</h2>
                    </div>

                    <ReactTable
                        data={this.state.deliveryOrders}
                        columns={[

                            {
                                Header: "Invoice",
                                accessor: "INVOICE_REFERENCE_NO",
                                className: "justify-start",
                                filterable: true,
                            },
                            {
                                Header: "Delivery Number",
                                accessor: "DELIVERY_NO",
                                className: "justify-start",
                                filterable: true,
                            },
                            {
                                Header: "Reference Number",
                                accessor: "REFERENCE_NO",
                                className: "justify-start",
                                filterable: true,
                            },
                            {
                                Header: "Print",
                                // accessor: "su",
                                width: 128,
                                Cell: row => (


                                    <div className="flex items-center w-8 h-8">
                                        {/* {this.state.search_type == 'invoice' ?  */}
                                        <IconButton

                                            onClick={(e) => {
                                                if (row) {

                                                    // reference_no = row.original.reference_no;
                                                    // in_out_bound = row.original.in_out_bound;
                                                    // alert(row)
                                                    console.log(row.original.ID_DELIVERY_NOTE, "eeeeeeeeeee")

                                                    this.getDeliveryNoteReport(row.original.ID_DELIVERY_NOTE)
                                                }
                                            }}

                                        >
                                            <Icon className="text-blue">print</Icon>
                                        </IconButton>
                                    </div>
                                )
                            }
                        ]}
                        //pageSize={this.state.records.length > 3 ? this.state.records.length : 3}
                        defaultPageSize={10}
                        className="-striped -highlight"

                    />

                </div>
            )


        }
    }
}



export default withStyles(styles, { withTheme: true })(withAlert(DeliveryNoteView));


// WEBPACK FOOTER //
// ./src/main/content/sales/deliveryNoteView/DeliveryNoteView.js